import React, { FC } from 'react';
import { View, Text, TouchableOpacity } from 'react-native';
import { DocketStatus } from '@oolio-group/domain';
import { useTranslation } from '@oolio-group/localization';
import { SegmentControlTabs } from '../../common/types';
import { CourseStatus } from '../../common/constants';
import SegmentControlStyles from './SegmentControl.styles';
import { useSession } from '../../hooks/useSession';

interface SegmentControlProps {
  testID: string;
  tabs: Array<SegmentControlTabs>;
  selectedTab: string;
  onChange: (tab: DocketStatus | CourseStatus) => void;
  disabled?: boolean;
}

const SegmentControl: FC<SegmentControlProps> = ({
  tabs,
  testID,
  selectedTab,
  onChange,
  disabled = false,
}) => {
  const styles = SegmentControlStyles();
  const { translate } = useTranslation();
  const { session } = useSession();
  const isCourseCallEnabled = session.kitchenDisplay?.isCourseCallEnabled;

  return (
    <View
      testID={testID}
      style={[
        styles.container,
        isCourseCallEnabled ? styles.containerExpanded : styles.containerNormal,
      ]}
    >
      {tabs?.map((tab, i) => (
        <TouchableOpacity
          key={i}
          testID={`segmentTab-${i}`}
          style={[styles.tab, selectedTab === tab.value && styles.active]}
          onPress={() => onChange(tab.value as DocketStatus | CourseStatus)}
          disabled={disabled}
        >
          <Text
            style={[
              styles.tabText,
              selectedTab === tab.value && styles.tabTextActive,
            ]}
          >
            {translate(`kitchenDisplay.${tab.label}`) || tab.label}
          </Text>
        </TouchableOpacity>
      ))}
    </View>
  );
};

export default SegmentControl;
